var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlreadyClaimed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 142,
    viewBox: "0 0 245 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.505 102.666C161.858 94.6279 153.279 89.6775 143.995 89.6775H108.025C96.4411 89.6775 86.2543 97.3411 83.0437 108.471L75.5241 134.539L151.332 136.753C153.055 136.803 154.479 135.42 154.479 133.696V123.945C154.479 121.708 157.418 120.882 158.583 122.791L166.106 135.117C167.202 136.912 169.198 137.957 171.298 137.835L186.327 136.957L166.505 102.666Z",
    fill: "#FFC100",
    stroke: "#716E6F",
    strokeWidth: 1.79243
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.623 79.815C142.429 79.815 158.485 63.7592 158.485 43.9534C158.485 24.1476 142.429 8.0918 122.623 8.0918C102.817 8.0918 86.7617 24.1476 86.7617 43.9534C86.7617 63.7592 102.817 79.815 122.623 79.815Z",
    fill: "#F5F1EE",
    stroke: "#716E6F",
    strokeWidth: 1.79308
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.133 59.416C132.409 63.4092 127.822 66.0306 122.623 66.0306C117.424 66.0306 112.838 63.4092 110.113 59.416",
    stroke: "#716E6F",
    strokeWidth: 1.79243,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.239 39.0984C133.443 40.3441 134.026 41.5397 134.987 42.5005C137.43 44.9431 141.39 44.9431 143.832 42.5005C144.744 41.5894 145.315 40.4672 145.546 39.2913",
    stroke: "#716E6F",
    strokeWidth: 1.79308,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8791 39.0984C100.084 40.3441 100.667 41.5397 101.628 42.5005C104.07 44.9431 108.031 44.9431 110.473 42.5005C111.384 41.5894 111.955 40.4672 112.187 39.2913",
    stroke: "#716E6F",
    strokeWidth: 1.79308,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.415 6.29883V6.29883C153.521 16.06 146.236 26.0227 135.992 26.0227H92.1396",
    stroke: "#716E6F",
    strokeWidth: 1.79308,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.451 0.919922V0.919922C144.639 13.6711 134.995 26.023 121.851 26.023H106.486",
    stroke: "#716E6F",
    strokeWidth: 1.79308,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0732422,
    y: 141.475,
    width: 8.71001,
    height: 244.86,
    rx: 4.355,
    transform: "rotate(-90 0.0732422 141.475)",
    fill: "#EAE4E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9901 92.2559C70.7739 92.2559 73.2574 94.0051 74.1949 96.6262L85.1923 127.37L108.904 129.033C109.882 129.102 110.641 129.915 110.641 130.895C110.641 131.927 109.805 132.762 108.774 132.762H81.5673C81.5474 132.763 81.5275 132.763 81.5076 132.763H26.3263C23.5425 132.763 21.059 131.014 20.1215 128.392L9.0859 97.5414C8.16471 94.9662 10.0737 92.2559 12.8088 92.2559H67.9901Z",
    fill: "#A19C9D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.56,
    cy: 4.01937,
    rx: 3.56,
    ry: 4.01937,
    transform: "matrix(-0.51857 0.855035 0.855035 0.51857 45.5684 109.115)",
    fill: "#F5F1EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.146 97.0771C177.596 95.3302 179.171 94.1094 180.975 94.1094H194.223C196.806 94.1094 198.696 96.5472 198.052 99.0495L190.132 129.797C189.682 131.544 188.107 132.765 186.303 132.765H173.055C170.472 132.765 168.582 130.327 169.227 127.825L177.146 97.0771Z",
    fill: "#EA7100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.997 123.29C199.328 119.041 195.202 115.84 191.168 117.218L185.533 119.142C183.302 119.904 181.734 121.915 181.539 124.264L181.421 125.684C181.134 129.141 183.863 132.105 187.332 132.105H192.824C195.921 132.105 198.497 129.723 198.737 126.635L198.997 123.29Z",
    fill: "#F5F1EE",
    stroke: "#716E6F",
    strokeWidth: 1.31796
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.862 110.741C139.862 110.361 139.55 110.049 139.16 110.049C138.776 110.049 138.459 110.361 138.459 110.741V110.76C138.459 111.14 138.771 111.452 139.16 111.452C139.55 111.452 139.862 111.14 139.862 110.76V110.741ZM139.544 110.745C139.544 110.536 139.373 110.365 139.159 110.365C138.95 110.365 138.774 110.536 138.774 110.745V110.755C138.774 110.964 138.945 111.135 139.159 111.135C139.373 111.135 139.544 110.964 139.544 110.755V110.745Z",
    fill: "#626262"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.637 108.357C137.026 108.357 137.338 108.674 137.338 109.064V111.183C137.338 111.573 137.026 111.89 136.637 111.89C136.247 111.89 135.936 111.573 135.936 111.183V109.064C135.936 108.674 136.247 108.357 136.637 108.357Z",
    fill: "#626262"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.109 111.008C134.499 111.008 134.811 111.315 134.811 111.695V112.382C134.811 112.762 134.499 113.069 134.109 113.069C133.72 113.069 133.408 112.762 133.408 112.382V111.695C133.408 111.315 133.725 111.008 134.109 111.008Z",
    fill: "#626262"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.689 108.357C142.078 108.357 142.39 108.674 142.39 109.064V111.183C142.39 111.573 142.078 111.89 141.689 111.89C141.299 111.89 140.987 111.573 140.987 111.183V109.064C140.987 108.674 141.299 108.357 141.689 108.357Z",
    fill: "#626262"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.211 111.008C144.601 111.008 144.912 111.315 144.912 111.695V112.382C144.912 112.762 144.601 113.069 144.211 113.069C143.821 113.069 143.51 112.762 143.51 112.382V111.695C143.51 111.315 143.826 111.008 144.211 111.008Z",
    fill: "#626262"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.159 106.301C139.549 106.301 139.861 106.632 139.861 107.036V108.508C139.861 108.912 139.549 109.243 139.159 109.243C138.77 109.243 138.458 108.912 138.458 108.508V107.036C138.458 106.627 138.775 106.301 139.159 106.301Z",
    fill: "#626262"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.162 98.3929C114.378 98.3929 110.642 89.8262 110.642 89.8262H135.024C135.024 89.8262 131.729 98.3929 123.162 98.3929Z",
    fill: "#F5F1EE",
    stroke: "#716E6F",
    strokeWidth: 1.79243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyClaimed);
export default __webpack_public_path__ + "static/media/already-claimed.e5e23a5e9f8bc90b04d1d3d2d5d376b6.svg";
export { ForwardRef as ReactComponent };